export var Telemetry = /*#__PURE__*/function () {
  function Telemetry() {
    this.performance = void 0;
    this.enabled = void 0;
    this.performance = {};
    this.enabled = true;
  }
  var _proto = Telemetry.prototype;
  _proto.reset = function reset() {
    this.performance = {};
  };
  return Telemetry;
}();
//# sourceMappingURL=types.js.map
